module.exports = __webpack_public_path__ + "media/images/undraw/business_deal-73ff181f4183081e55dd34f104188bf7.png";